var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlockFilled = function SvgUnlockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.001 0a4.145 4.145 0 0 0-4.154 4.154v2.77a2.777 2.777 0 0 0-2.769 2.768v5.539A2.777 2.777 0 0 0 4.848 18h8.307a2.777 2.777 0 0 0 2.77-2.77V9.693a2.777 2.777 0 0 0-2.77-2.769H6.232v-2.77c0-1.575 1.194-2.768 2.77-2.768 1.575 0 2.768 1.193 2.768 2.769v.692h1.385v-.692A4.145 4.145 0 0 0 9.001 0m0 10.385c.762 0 1.385.623 1.385 1.384 0 .485-.277.96-.692 1.169v1.6c0 .416-.277.693-.693.693s-.692-.277-.692-.692v-1.602c-.415-.207-.692-.683-.692-1.168 0-.761.623-1.384 1.384-1.384"
  })));
};
export default SvgUnlockFilled;